export const allVariables = [
  { id: 1, value: "Estado", category: "Endereço" },
  { id: 2, value: "Cidade", category: "Endereço" },
  { id: 3, value: "Rua", category: "Endereço" },
  { id: 4, value: "Número", category: "Endereço" },
  { id: 5, value: "Complemento", category: "Endereço" },
  { id: 6, value: "Bairro", category: "Endereço" },
  { id: 7, value: "CEP", category: "Endereço" },
  { id: 8, value: "País", category: "Endereço" },
  { id: 9, value: "WhatsApp", category: "Contato" },
  { id: 10, value: "Email", category: "Contato" },
  { id: 11, value: "Emissão", category: "Referências Financeiras" },
  { id: 12, value: "Status", category: "Referências Financeiras" },
  { id: 13, value: "Descrição", category: "Referências Financeiras" },
  { id: 14, value: "Serviço", category: "Referências Financeiras" },
  { id: 15, value: "Banco", category: "Referências Financeiras" },
  { id: 16, value: "Mês_Recebimento", category: "Referências Financeiras" },
  { id: 17, value: "Ano_Recebimento", category: "Referências Financeiras" },
  { id: 18, value: "Dia_Recebimento", category: "Referências Financeiras" },
  { id: 19, value: "Dias_Vencimento", category: "Referências Financeiras" },
  { id: 20, value: "Nome", category: "Informações Pessoais" },
  { id: 21, value: "Cliente_ID", category: "Informações Pessoais" },
  { id: 22, value: "Contrato_ID", category: "Informações Pessoais" },
  { id: 23, value: "Nome_Completo", category: "Informações Pessoais" },
  { id: 24, value: "Data_Nascimento", category: "Informações Pessoais" },
  { id: 25, value: "Documento_01", category: "Informações Pessoais" },
  { id: 26, value: "Documento_02", category: "Informações Pessoais" },
  { id: 27, value: "Telefone_01", category: "Contato" },
  { id: 28, value: "Telefone_02", category: "Contato" },
  { id: 29, value: "Telefone_03", category: "Contato" },
  { id: 30, value: "Social_Media_01", category: "Contato" },
  { id: 31, value: "Social_Media_02", category: "Contato" },
  { id: 32, value: "ID_Fatura", category: "Referências Financeiras" },
  { id: 33, value: "Código_Barras", category: "Referências Financeiras" },
  { id: 34, value: "Data_Vencimento", category: "Referências Financeiras" },
  { id: 35, value: "Valor_Total", category: "Referências Financeiras" },
  { id: 36, value: "Descrição_Detalhada", category: "Referências Financeiras" },
  { id: 37, value: "Link_PDF", category: "Referências Financeiras" },
  { id: 38, value: "Link_Imagem", category: "Outros" },
  { id: 39, value: "Natureza_Financeira", category: "Referências Financeiras" },
  { id: 40, value: "Tipo_Faturamento", category: "Referências Financeiras" },
  { id: 41, value: "Referência_Contrato", category: "Referências Financeiras" },
  { id: 42, value: "Valor_Pago", category: "Referências Financeiras" },
  { id: 43, value: "Referência_01", category: "Referências Financeiras" },
  { id: 44, value: "Referência_02", category: "Referências Financeiras" },
  { id: 45, value: "Referência_03", category: "Referências Financeiras" },
  { id: 46, value: "Referência_04", category: "Referências Financeiras" },
  { id: 47, value: "Referência_05", category: "Referências Financeiras" },
  { id: 48, value: "CPF_CNPJ", category: "Referências Financeiras" },
  { id: 49, value: "Multa_Modalidade", category: "Referências Financeiras" },
  { id: 50, value: "Multa_Valor", category: "Referências Financeiras" },
  { id: 51, value: "Juros_Modalidade", category: "Referências Financeiras" },
  { id: 52, value: "Juros_Valor", category: "Referências Financeiras" },
  {
    id: 53,
    value: "Abatimento_Modalidade",
    category: "Referências Financeiras",
  },
  {
    id: 54,
    value: "Abatimento_Valor_Perc",
    category: "Referências Financeiras",
  },
  {
    id: 55,
    value: "Desconto_01_Lista_Data",
    category: "Referências Financeiras",
  },
  {
    id: 56,
    value: "Desconto_01_Valor_Perc",
    category: "Referências Financeiras",
  },
  {
    id: 57,
    value: "Desconto_02_Lista_Data",
    category: "Referências Financeiras",
  },
  {
    id: 58,
    value: "Desconto_02_Valor_Perc",
    category: "Referências Financeiras",
  },
  {
    id: 59,
    value: "Desconto_03_Lista_Data",
    category: "Referências Financeiras",
  },
  {
    id: 60,
    value: "Desconto_03_Valor_Perc",
    category: "Referências Financeiras",
  },
  { id: 61, value: "Desconto_Modalidade", category: "Referências Financeiras" },
  { id: 62, value: "Código_PIX", category: "Referências Financeiras" },
  { id: 63, value: "Data_Emissão", category: "Referências Financeiras" },
];

export const categories = [
  "Tudo",
  ...new Set(allVariables.map((v) => v.category)),
];
